import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { UseI18n } from '../../../../common/hooks/useI18n'
import { Element } from '../../../../common/html/element'
import { Radio } from '../../../../common/html/radio'
import { PopupAction } from '../../../../common/popup/PopupAction'
import { resetStoreHeaderCompanyAnalysis } from '../../../../companyAnalysis/common/header/companyInfo/store/slice'
import { jsonToString } from './helper'
import classes from './index.module.scss'
import {
  selectCompanyType,
  selectDefaultTemplate,
  selectIsHasCompanyName,
  selectIsHasPortName,
  selectIsHasReportSubtitle,
  selectName,
  selectPanelById,
  selectPanelId,
  selectReportSubtitle,
  selectReportTitle,
  setBlankTemplate,
} from './store/slice'

export const ButtonBlankTemplate = ({ saveTemplate }) => {
  const dispatch = useDispatch()

  const panelId = useSelector(selectPanelId)
  const panelById = useSelector(selectPanelById)
  const reportTitle = useSelector(selectReportTitle)
  const isHasReportSubtitle = useSelector(selectIsHasReportSubtitle)
  const reportSubtitle = useSelector(selectReportSubtitle)
  const companyType = useSelector(selectCompanyType)
  const defaultTemplate = useSelector(selectDefaultTemplate)
  const name = useSelector(selectName)
  const isHasCompanyName = useSelector(selectIsHasCompanyName)
  const isHasPortName = useSelector(selectIsHasPortName)

  const isNotHasChange =
    name.trim() === defaultTemplate.templateName &&
    jsonToString(panelId) === jsonToString(defaultTemplate.panelId) &&
    jsonToString(panelById) === jsonToString(defaultTemplate.panelById)

  const [isShowWarning, setShowWarning] = useState(false)
  const [isShowSave, setShowSave] = useState(false)
  const [valueInput, setValueInput] = useState('')

  const placeHolder = UseI18n('preferenceSetting.PLH_INPUT')
  const changeInput = (e) => setValueInput(e.target.value)

  const actionNoSaveTemplate = () => {
    setShowWarning(false)
    dispatch(setBlankTemplate())
    dispatch(resetStoreHeaderCompanyAnalysis())
  }

  const submit = async () => {
    setShowSave(false)

    const panels = panelId.map((id) => panelById[id])
    const data = {
      templateName: valueInput.trim(),
      templateData: {
        panels,
        reportTitle,
        isHasReportSubtitle,
        reportSubtitle,
        isHasCompanyName,
        isHasPortName,
      },
      companyType,
    }

    const result = await saveTemplate(data)

    if (result) {
      actionNoSaveTemplate()
    }
  }

  const onClickBankTemplate = () => {
    if (isNotHasChange) {
      actionNoSaveTemplate()
      return
    }
    setShowWarning(true)
  }

  const isDisableSubmit = !valueInput?.trim()

  return (
    <>
      <Element
        style={{ border: '1px solid #6D9DCF', color: '#0553A5' }}
        className={classes.btnReset2}
        onClick={onClickBankTemplate}
      >
        <Translate value="dynamicReport.BLANK_TEMPLATE" />
      </Element>
      <PopupAction
        isShow={isShowWarning}
        title="preferenceSetting.SAVE_CHANGE"
        handleClose={() => {
          setShowWarning(false)
        }}
        btnCancel={{
          label: 'common.NO',
          event: actionNoSaveTemplate,
          isI18n: true,
        }}
        btnSubmit={{
          label: 'common.YES',
          event: () => setShowSave(true),
          isI18n: true,
        }}
      >
        <Translate value="preferenceSetting.NOTE_BLANK_TEMPLATE" />
      </PopupAction>
      <PopupAction
        isShow={isShowSave}
        title="preferenceSetting.SAVE_CHANGE"
        handleClose={() => {
          setShowSave(false)
        }}
        btnCancel={{
          label: 'preferenceSetting.CANCEL',
          event: () => {
            setShowSave(false)
          },
          isI18n: true,
        }}
        btnSubmit={{
          label: 'preferenceSetting.SAVE',
          event: submit,
          isI18n: true,
          disabled: isDisableSubmit,
        }}
      >
        <Element>
          <Element style={{ marginTop: 0 }}>
            <Radio
              title="preferenceSetting.SAVE_AS"
              value={true}
              activeValue={true}
              titleStyle={{ fontWeight: 600, color: '#3A414B' }}
            />
            <Element className="mt1">
              <Element
                elementName="input"
                style={{ border: '1px solid #E0E0E0' }}
                className={classes.inputSaveAs}
                placeholder={placeHolder}
                value={valueInput}
                onChange={changeInput}
              />
            </Element>
          </Element>
        </Element>
      </PopupAction>
    </>
  )
}
